<template>
    <div class="">
        <Header></Header>

        <!-- Main -->
        <main class="u-main">
            <Navigation></Navigation>

            <div class="u-content">
                <div class="u-body min-h-700">
                    <h1 class="h2 mb-2 text-capitalize">{{ refs }}

                        <!-- Tenants -->
                        <div class="pull-right ui-mt-15">
                            <span class="btn btn-dark btn-sm">
                                <span class="btn-icon ti-home mr-2"></span>
                                <span> {{ tenant_name }} </span>
                            </span>
                        </div>
                        <!-- End Tenants -->

                    </h1>

                    <!-- Breadcrumb -->
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">
                                <router-link :to="{ name: 'dashboard' }">Home</router-link>
                            </li>
                            <li class="breadcrumb-item text-capitalize">
                                <router-link :to="{ name: refs }">{{ refs }}</router-link>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page">Edit</li>
                        </ol>
                    </nav>
                    <!-- End Breadcrumb -->


            <div v-if="pgLoading" class="row h-100">
                <div class="container text-center">
                    <div class="spinner-grow mt-5" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
            </div>

            <form v-if="!pgLoading" @submit.prevent="editRow" enctype="multipart/form-data" class="h-100">

                <!-- Content -->
                <div class="tab-content">
                    <div class="row">


                <!-- ******* Cards ******* -->
                <div class="col-md-8 mb-5">


                    <!-- Card Restaurant -->
                    <div class="card">
                        <div class="card-body">
                            <div id="accordion" class="accordion">
                                <div id="TabRestaurant" class="card-header">
                                    <h2 class="h4 card-header-title"
                                        @click="collapseToggle('Restaurant')"
                                        aria-expanded="false"
                                        aria-controls="collapseRestaurant"
                                        data-toggle="collapse"
                                        data-target="#collapseRestaurant">Restaurant
                                        <span id="iconToggleRestaurant"
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseRestaurant"
                                    class="collapse show"
                                    aria-labelledby="TabRestaurant"
                                    data-parent="#accordion">

                                    <div class="col-12 pt-3">

                                        <!-- Title -->
                                        <div class="form-group">
                                            <label for="inputText1">Title</label>
                                            <input class="form-control"
                                                    id="inputText1"
                                                    type="text"
                                                    v-model="row.title">
                                        </div>
                                        <!-- End Title -->

                                        <!-- Slug -->
                                        <div class="form-group">
                                            <label for="inputText2">Slug</label>
                                            <input class="form-control"
                                                    id="inputText2"
                                                    type="text"
                                                    v-model="row.slug"
                                                    @keydown.space.prevent>
                                        </div>
                                        <!-- End Slug -->

                                        <div class="row">
                                            <!-- Sort -->
                                            <div class="form-group col-6">
                                                <label for="inputText4">Sort</label>
                                                <input class="form-control"
                                                        id="inputTex4"
                                                        type="number"
                                                        min="0"
                                                        v-model.number="row.sort">
                                            </div>
                                            <!-- End Sort -->

                                            <!-- Stars -->
                                            <div class="form-group col-6">
                                                <label for="inputText5">Stars</label>
                                                <input class="form-control"
                                                        id="inputTex5"
                                                        type="number"
                                                        min="0"
                                                        max="5"
                                                        v-model.number="row.stars">
                                            </div>
                                            <!-- End Stars -->
                                        </div>

                                        <div class="row">
                                            <!-- Stars No -->
                                            <div class="form-group col-6">
                                                <label for="inputTextStarsNo">Stars No</label>
                                                <input class="form-control"
                                                        id="inputTextStarsNo"
                                                        type="number"
                                                        min="0"
                                                        v-model.number="row.stars_no">
                                            </div>
                                            <!-- End Stars No -->

                                            <!-- Location -->
                                            <div class="form-group col-6">
                                                <label for="inputTextLocation">Location</label>
                                                <input class="form-control"
                                                        id="inputTextLocation"
                                                        type="text"
                                                        v-model="row.location">
                                            </div>
                                            <!-- End Location -->
                                        </div>

                                        <div class="row">
                                            <!-- Phone Number -->
                                            <div class="form-group col-6">
                                                <label for="inputTextPhoneNumber">Phone Number</label>
                                                <input class="form-control"
                                                        id="inputTextPhoneNumber"
                                                        type="text"
                                                        v-model="row.phone_number">
                                            </div>
                                            <!-- End Phone Number -->

                                            <!-- Services -->
                                            <div class="form-group col-6">
                                                <label for="inputTextServices">Services</label>
                                                <input class="form-control"
                                                        id="inputTextServices"
                                                        type="text"
                                                        v-model="row.services">
                                            </div>
                                            <!-- End Services -->
                                        </div>

                                        <div class="row">
                                            <!-- Popular -->
                                            <div class="form-group col-6">
                                                <label for="inputTextPopular">Popular</label>
                                                <select class="form-control"
                                                        id="inputTextPopular"
                                                        v-model="row.popular">
                                                    <option value="">Select Popular</option>
                                                    <option value="popular">Popular</option>
                                                    <option value="topRated">Top rated</option>
                                                    <option value="bestSeller">Best seller</option>
                                                    <option value="bestDeal">Best deal</option>
                                                    <option value="easterOffer">Easter offer</option>
                                                </select>
                                            </div>
                                            <!-- End Popular -->
                                        </div>

                                        <div class="row">
                                            <!-- Latitude -->
                                            <div class="form-group col-6">
                                                <label for="inputTextLatitude">Latitude</label>
                                                <input class="form-control"
                                                        id="inputTextLatitude"
                                                        type="number"
                                                        step="any"
                                                        v-model="row.latitude">
                                            </div>
                                            <!-- End Latitude -->

                                            <!-- Longitude -->
                                            <div class="form-group col-6">
                                                <label for="inputTextLongitude">Longitude</label>
                                                <input class="form-control"
                                                        id="inputTextLongitude"
                                                        type="number"
                                                        step="any"
                                                        v-model="row.longitude">
                                            </div>
                                            <!-- End Longitude -->
                                        </div>

                                        <!-- Body -->
                                        <div class="form-group">
                                            <label for="inputEditor1">Body</label>
                                            <editor
                                                id="inputEditor1"
                                                v-model="row.body"
                                                :api-key="editor.api_key"
                                                :init="{
                                                    height: 300,
                                                    menubar: editor.menubar,
                                                    plugins: editor.plugins,
                                                    external_plugins: editor.external_plugins,
                                                    toolbar: editor.toolbar
                                                }"
                                            />
                                        </div>
                                        <!-- End Body -->

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Card Restaurant -->

                    <!-- Card Opening Hours -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordion" class="accordion">
                                <div id="TabOpeningHours" class="card-header">
                                    <h2 class="h4 card-header-title"
                                        @click="collapseToggle('OpeningHours')"
                                        aria-expanded="false"
                                        aria-controls="collapseOpeningHours"
                                        data-toggle="collapse"
                                        data-target="#collapseOpeningHours">Opening Hours
                                        <span id="iconToggleOpeningHours"
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseOpeningHours"
                                    class="collapse"
                                    aria-labelledby="TabOpeningHours"
                                    data-parent="#accordion">

                                    <div class="col-12 pt-3">

                                        <div v-for="(day, idx) in row.openingHours"
                                             :key="'day_'+idx"
                                             class="row col-12 ui-ml-unset align-items-center mb-2">
                                            <div class="col-3">
                                                <label class="mb-0">{{ dayNames[idx] }}</label>
                                            </div>
                                            <div class="col-3">
                                                <input class="form-control"
                                                       type="time"
                                                       :disabled="day.is_closed"
                                                       v-model="day.open_time">
                                            </div>
                                            <div class="col-3">
                                                <input class="form-control"
                                                       type="time"
                                                       :disabled="day.is_closed"
                                                       v-model="day.close_time">
                                            </div>
                                            <div class="col-3">
                                                <div class="custom-control custom-checkbox">
                                                    <input :id="'dayClosed'+idx"
                                                           class="custom-control-input"
                                                           type="checkbox"
                                                           v-model="day.is_closed">
                                                    <label class="custom-control-label"
                                                           :for="'dayClosed'+idx">Closed</label>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Card Opening Hours -->

                    <!-- Card Featured Menus -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordion" class="accordion">
                                <div id="TabFeaturedMenus" class="card-header">
                                    <h2 class="h4 card-header-title"
                                        @click="collapseToggle('FeaturedMenus')"
                                        aria-expanded="false"
                                        aria-controls="collapseFeaturedMenus"
                                        data-toggle="collapse"
                                        data-target="#collapseFeaturedMenus">Featured Menus
                                        <span id="iconToggleFeaturedMenus"
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseFeaturedMenus"
                                    class="collapse"
                                    aria-labelledby="TabFeaturedMenus"
                                    data-parent="#accordion">

                                    <div class="col-12 pt-3">

                                        <!-- For Loop -->
                                        <div v-for="i in row.menu_key"
                                            :key="'menu'+i"
                                            :id="'menuFrm_'+i"
                                            class="ui-for-div">

                                            <!-- Remove -->
                                            <div class="pull-right ui-mt-10">
                                                <button type="button"
                                                    class="btn btn-danger btn-circle btn-with-icon btn-sm"
                                                    @click="removeMenuOption(i)">
                                                    <span class="btn-icon ti-close font-bold"></span>
                                                </button>
                                            </div>
                                            <!-- End Remove -->

                                            <div class="form-group">
                                                <label :for="'mImageText'+i">Menu Image</label>
                                               <p>
                                                    <img v-if="(row.menu_image_preview[i])"
                                                        :src="row.menu_image_preview[i]"
                                                        class="custom-image">
                                                </p>
                                                <input class="form-control"
                                                        :id="'mImageText'+i"
                                                        type="file"
                                                        accept="image/*"
                                                        v-on:change="onMenuImageChange($event, i)">
                                            </div>

                                            <div class="col-12 row no-padding ui-ml-unset">
                                                <div class="col-6 no-lpadding">
                                                    <div class="form-group">
                                                        <label :for="'mAltText'+i">Image Alt</label>
                                                        <input class="form-control"
                                                                :id="'mAltText'+i"
                                                                type="text"
                                                                v-model="row.menu_image_alt[i]">
                                                    </div>
                                                </div>

                                                <div class="col-6 no-rpadding">
                                                    <div class="form-group">
                                                        <label :for="'mTitleText'+i">Image Title / Caption</label>
                                                        <input class="form-control"
                                                                :id="'mTitleText'+i"
                                                                type="text"
                                                                v-model="row.menu_image_title[i]">
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label :for="'mIframeText'+i">Menu Iframe</label>
                                                <textarea class="form-control"
                                                        :id="'mIframeText'+i"
                                                        rows="3"
                                                        placeholder="Paste iframe embed code"
                                                        v-model="row.menu_iframe[i]"></textarea>
                                            </div>

                                        </div>

                                            <!-- Add more -->
                                            <div class="row pull-right">
                                                <button type="button"
                                                    class="btn btn-dark btn-circle btn-with-icon"
                                                    @click="opnMenuFrm()">
                                                    <span class="btn-icon ti-plus font-bold"></span>
                                                </button>
                                            </div>
                                            <!-- End more -->
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Card Featured Menus -->

                    <!-- Card Galleries -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordion" class="accordion">
                                <div id="TabGalleries" class="card-header">
                                    <h2 class="h4 card-header-title"
                                        @click="collapseToggle('Galleries')"
                                        aria-expanded="false"
                                        aria-controls="collapseGalleries"
                                        data-toggle="collapse"
                                        data-target="#collapseGalleries">Galleries
                                        <span id="iconToggleGalleries"
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseGalleries"
                                    class="collapse"
                                    aria-labelledby="TabGalleries"
                                    data-parent="#accordion">

                                    <div class="col-12 pt-3">

                                        <!-- For Loop -->
                                        <div v-for="i in row.gallery_key"
                                            :key="'gallery'+i"
                                            :id="'galleryFrm_'+i"
                                            class="ui-for-div">

                                            <!-- Remove -->
                                            <div class="pull-right ui-mt-10">
                                                <button type="button"
                                                    class="btn btn-danger btn-circle btn-with-icon btn-sm"
                                                    @click="removeGalleryOption(i)">
                                                    <span class="btn-icon ti-close font-bold"></span>
                                                </button>
                                            </div>
                                            <!-- End Remove -->

                                            <div class="form-group">
                                                <label :for="'gImageText'+i">Image</label>
                                               <p>
                                                    <img v-if="(row.gallery_image_preview[i])"
                                                        :src="row.gallery_image_preview[i]"
                                                        class="custom-image">
                                                </p>
                                                <input class="form-control"
                                                        :id="'gImageText'+i"
                                                        type="file"
                                                        accept="image/*"
                                                        v-on:change="onGalleryImageChange($event, i)">
                                            </div>

                                            <div class="col-12 row no-padding ui-ml-unset">
                                                <div class="col-6 no-lpadding">
                                                    <div class="form-group">
                                                        <label :for="'gAltText'+i">Image Alt</label>
                                                        <input class="form-control"
                                                                :id="'gAltText'+i"
                                                                type="text"
                                                                v-model="row.gallery_image_alt[i]">
                                                    </div>
                                                </div>

                                                <div class="col-6 no-rpadding">
                                                    <div class="form-group">
                                                        <label :for="'gTitleText'+i">Image Title</label>
                                                        <input class="form-control"
                                                                :id="'gTitleText'+i"
                                                                type="text"
                                                                v-model="row.gallery_image_title[i]">
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                            <!-- Add more -->
                                            <div class="row pull-right">
                                                <button type="button"
                                                    class="btn btn-dark btn-circle btn-with-icon"
                                                    @click="opnGalleryFrm()">
                                                    <span class="btn-icon ti-plus font-bold"></span>
                                                </button>
                                            </div>
                                            <!-- End more -->
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Card Galleries -->

                </div>
                 <!-- ******* End Cards ******** -->


                <!-- ******* Navbar ******** -->
                <div class="col-md-4 mb-5">

                    <!-- Nav Language -->
                    <div class="card">
                        <div class="card-body">
                            <div id="accordionNav" class="accordion">
                                <div id="NavLanguage" class="card-header">
                                    <h2 class="h4 card-header-title"
                                        @click="collapseToggle('Language')"
                                        aria-expanded="false"
                                        aria-controls="collapseNavLanguage"
                                        data-toggle="collapse"
                                        data-target="#collapseNavLanguage">Language
                                        <span id="iconToggleLanguage"
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseNavLanguage"
                                    class="collapse"
                                    aria-labelledby="NavLanguage"
                                    data-parent="#accordionNav">

                                <div class="col-12 pt-3">
                                    <!-- Language -->
                                    <div class="form-group">
                                        <div v-if="languageLoading" class="text-center">
                                            <span class="spinner-grow spinner-grow-sm mr-1"
                                                role="status"
                                                aria-hidden="true">
                                            </span>
                                        </div>
                                        <select class="form-control custom-select"
                                                v-if="!languageLoading"
                                                v-model="row.language_id">
                                                <option value="">Select Language</option>
                                                <option v-for="(language, index) in languages"
                                                        :key="index"
                                                        :value="language.id">
                                                        {{ language.name }}
                                                </option>
                                        </select>
                                    </div>
                                    <!-- End Language -->
                                </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Nav Language -->

                    <!-- Nav Category -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordionNav" class="accordion">
                                <div id="NavCategory" class="card-header">
                                    <h2 class="h4 card-header-title"
                                        @click="collapseToggle('Category')"
                                        aria-expanded="false"
                                        aria-controls="collapseNavCategory"
                                        data-toggle="collapse"
                                        data-target="#collapseNavCategory">Category
                                        <span id="iconToggleCategory"
                                                class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseNavCategory"
                                    class="collapse"
                                    aria-labelledby="NavCategory"
                                    data-parent="#accordionNav">
                                    <div class="col-12 pt-3">
                                        <div class="form-group">
                                            <div v-if="categoryLoading" class="text-center">
                                                <span class="spinner-grow spinner-grow-sm mr-1"
                                                    role="status"
                                                    aria-hidden="true">
                                                </span>
                                            </div>
                                            <select class="form-control custom-select"
                                                v-if="!categoryLoading"
                                                v-model="row.category_id">
                                                <option value="">Select Category</option>
                                                <option v-for="(category, index) in categories"
                                                        :key="index"
                                                        :value="category.id">
                                                        {{ category.title }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Nav Category -->

                    <!-- Nav Multiple Tags -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordionNav" class="accordion">
                                <div id="NavMultipleTags" class="card-header">
                                    <h2 class="h4 card-header-title"
                                        @click="collapseToggle('MultipleTags')"
                                        aria-expanded="false"
                                        aria-controls="collapseNavMultipleTags"
                                        data-toggle="collapse"
                                        data-target="#collapseNavMultipleTags">Multiple Tags
                                        <span id="iconToggleMultipleTags"
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow black pull-right">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseNavMultipleTags"
                                    class="collapse"
                                    aria-labelledby="NavMultipleTags"
                                    data-parent="#accordionNav">

                                    <div class="col-12 pt-3">
                                        <div class="form-group">
                                            <div v-if="tagsLoading" class="text-center">
                                                <span class="spinner-grow spinner-grow-sm mr-1"
                                                    role="status"
                                                    aria-hidden="true">
                                                </span>
                                            </div>
                                            <multiselect v-if="!tagsLoading"
                                                    id="multiselectTags"
                                                    ref="multiselectRef"
                                                    autocomplete="on"
                                                    v-model="row.tagsValues"
                                                    :options="tagsOptions"
                                                    :multiple="true"
                                                    :close-on-select="false"
                                                    :clear-on-select="false"
                                                    :hide-selected="true"
                                                    :preserve-search="true"
                                                    :taggable="false"
                                                    placeholder="Type to search tags"
                                                    :preselect-first="false">
                                            </multiselect>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Nav Multiple Tags -->

                    <!-- Nav Multiple Icons -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordionNav" class="accordion">
                                <div id="NavMultipleIcons" class="card-header">
                                    <h2 class="h4 card-header-title"
                                        @click="collapseToggle('MultipleIcons')"
                                        aria-expanded="false"
                                        aria-controls="collapseNavMultipleIcons"
                                        data-toggle="collapse"
                                        data-target="#collapseNavMultipleIcons">Multiple Icons
                                        <span id="iconToggleMultipleIcons"
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow black pull-right">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseNavMultipleIcons"
                                    class="collapse"
                                    aria-labelledby="NavMultipleIcons"
                                    data-parent="#accordionNav">

                                    <div class="col-12 pt-3">
                                        <div class="form-group">
                                            <div v-if="iconsLoading" class="text-center">
                                                <span class="spinner-grow spinner-grow-sm mr-1"
                                                    role="status"
                                                    aria-hidden="true">
                                                </span>
                                            </div>
                                            <multiselect v-if="!iconsLoading"
                                                    id="multiselectIcons"
                                                    ref="multiselectRef"
                                                    autocomplete="on"
                                                    v-model="row.iconsValues"
                                                    :options="iconsOptions"
                                                    :multiple="true"
                                                    :close-on-select="false"
                                                    :clear-on-select="false"
                                                    :hide-selected="true"
                                                    :preserve-search="true"
                                                    :taggable="false"
                                                    placeholder="Type to search icons"
                                                    :preselect-first="false">
                                            </multiselect>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Nav Multiple Icons -->

                    <!-- Linked FAQs -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordionNav" class="accordion">
                                <div id="NavFaqs" class="card-header">
                                    <h2 class="h4 card-header-title"
                                        @click="collapseToggle('Faqs')"
                                        aria-expanded="false"
                                        aria-controls="collapseNavFaqs"
                                        data-toggle="collapse"
                                        data-target="#collapseNavFaqs">Linked FAQs
                                        <span id="iconToggleFaqs"
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseNavFaqs"
                                    class="collapse"
                                    aria-labelledby="NavFaqs"
                                    data-parent="#accordionNav">
                                    <div class="col-12 pt-3">
                                        <p class="text-muted small">Order follows selection order in the list.</p>
                                        <div class="form-group">
                                            <div v-if="faqsLoading" class="text-center">
                                                <span class="spinner-grow spinner-grow-sm mr-1"
                                                    role="status"
                                                    aria-hidden="true">
                                                </span>
                                            </div>
                                            <multiselect v-if="!faqsLoading"
                                                id="multiselect-faqs-restaurants"
                                                v-model="row.faqsValues"
                                                :options="faqsOptions"
                                                :multiple="true"
                                                :close-on-select="false"
                                                :clear-on-select="false"
                                                :hide-selected="true"
                                                :preserve-search="true"
                                                :taggable="false"
                                                label="title"
                                                track-by="id"
                                                placeholder="Search and select FAQs"
                                                :preselect-first="false">
                                            </multiselect>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Linked FAQs -->

                    <!-- Nav Image -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordionNav" class="accordion">
                                <div id="NavImage" class="card-header">
                                    <h2 class="h4 card-header-title"
                                        @click="collapseToggle('Image')"
                                        aria-expanded="false"
                                        aria-controls="collapseNavImage"
                                        data-toggle="collapse"
                                        data-target="#collapseNavImage">Featured Image
                                        <span id="iconToggleImage"
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseNavImage"
                                        class="collapse"
                                        aria-labelledby="NavImage"
                                        data-parent="#accordionNav">

                                    <div class="col-12 pt-3">
                                        <!-- Image -->
                                        <div class="form-group">
                                            <label>Image</label>
                                            <img v-if="row.preview"
                                                :src="row.preview"
                                                class="mb-2 custom-image">
                                            <input type="file"
                                                class="form-control"
                                                ref="myDropify"
                                                v-on:change="onImageChange"
                                                accept="image/*">
                                        </div>
                                        <!-- End Image -->

                                        <!-- Image alt -->
                                        <div class="form-group">
                                                <label>Image alt</label>
                                                <input type="text"
                                                    class="form-control"
                                                    v-model="row.image_alt">
                                        </div>
                                        <!-- End Image alt -->

                                        <!-- Image title -->
                                        <div class="form-group">
                                            <label>Image title</label>
                                            <input type="text"
                                                class="form-control"
                                                v-model="row.image_title">
                                        </div>
                                        <!-- End Image title -->

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Nav Image -->

                    <!-- Nav Meta -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordionNav" class="accordion">
                                <div id="NavMeta" class="card-header">
                                    <h2 class="h4 card-header-title"
                                        @click="collapseToggle('Meta')"
                                        aria-expanded="false"
                                        aria-controls="collapseNavMeta"
                                        data-toggle="collapse"
                                        data-target="#collapseNavMeta">Meta / SEO
                                        <span id="iconToggleMeta"
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseNavMeta"
                                        class="collapse"
                                        aria-labelledby="NavMeta"
                                        data-parent="#accordionNav">

                                    <div class="col-12 pt-3">
                                        <!-- Meta Title -->
                                        <div class="form-group">
                                            <label>Meta Title
                                                <span class="text-muted" v-if="row.meta_title" v-text="(row.meta_title.length)"></span>
                                            </label>
                                            <input type="text"
                                                class="form-control"
                                                v-model="row.meta_title">
                                        </div>
                                        <!-- End Meta Title -->

                                        <!-- Meta Keywords -->
                                        <div class="form-group">
                                            <label>Meta Keywords
                                                <span class="text-muted" v-if="row.meta_keywords" v-text="(row.meta_keywords.length)"></span>
                                            </label>
                                            <input type="text"
                                                class="form-control"
                                                v-model="row.meta_keywords">
                                        </div>
                                        <!-- End Meta Keywords -->

                                        <!-- Meta Description -->
                                        <div class="form-group">
                                            <label>Meta Description
                                                <span class="text-muted" v-if="row.meta_description" v-text="(row.meta_description.length)"></span>
                                            </label>
                                            <textarea
                                                class="form-control"
                                                rows="3"
                                                v-model="row.meta_description"></textarea>
                                        </div>
                                        <!-- End Meta Description -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Nav Meta -->

                    <!-- Nav Status -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordionNav" class="accordion">
                                <div id="NavStatus" class="card-header">
                                    <h2 class="h4 card-header-title"
                                        @click="collapseToggle('Status')"
                                        aria-expanded="false"
                                        aria-controls="collapseNavStatus"
                                        data-toggle="collapse"
                                        data-target="#collapseNavStatus">Status & Visibility
                                        <span id="iconToggleStatus"
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseNavStatus"
                                    class="collapse"
                                    aria-labelledby="NavStatus"
                                    data-parent="#accordionNav">

                                    <div class="col-12 pt-3">
                                        <!-- Status -->
                                        <div class="form-group">
                                            <div class="custom-control custom-switch mb-2">
                                                <input type="checkbox"
                                                    class="custom-control-input"
                                                    id="customSwitch1"
                                                    :checked="row.status"
                                                    @click="onStatus">
                                                <label class="custom-control-label"
                                                    for="customSwitch1"
                                                    v-html="(row.status) ? 'Active' : 'Inactive'">
                                                </label>
                                            </div>
                                        </div>
                                        <!-- End Status -->

                                        <!-- View in home -->
                                            <div class="form-group">
                                                <div class="custom-control custom-switch mb-2">
                                                    <input type="checkbox"
                                                        class="custom-control-input"
                                                        id="customSwitch2"
                                                        :checked="row.view_in_home"
                                                        @click="onViewInHome">
                                                    <label class="custom-control-label"
                                                        for="customSwitch2"
                                                        v-html="(row.view_in_home)
                                                            ? 'Show In Home'
                                                            : 'Hide In Home'">
                                                    </label>
                                                </div>
                                            </div>
                                            <!-- End View in home -->

                                            <!-- View in menu -->
                                            <div class="form-group">
                                                <div class="custom-control custom-switch mb-2">
                                                    <input type="checkbox"
                                                        class="custom-control-input"
                                                        id="customSwitch5"
                                                        :checked="row.view_in_menu"
                                                        @click="onViewInMenu">
                                                    <label class="custom-control-label"
                                                        for="customSwitch5"
                                                        v-html="(row.view_in_menu)
                                                            ? 'Show In Menu'
                                                            : 'Hide In Menu'">
                                                    </label>
                                                </div>
                                            </div>
                                            <!-- End View in menu -->

                                            <!-- Menu Order -->
                                            <div class="no-rpadding">
                                                <div class="form-group">
                                                    <input class="form-control"
                                                            v-bind:style="{display: orderDisplay}"
                                                            placeholder="Order In Menu"
                                                            id="inputText8"
                                                            type="number"
                                                            min="0"
                                                            v-model.number="row.menu_order">
                                                </div>
                                            </div>
                                            <!-- End Menu Order -->

                                            <!-- View in sub menu -->
                                            <div class="form-group">
                                                <div class="custom-control custom-switch mb-2">
                                                    <input type="checkbox"
                                                        class="custom-control-input"
                                                        id="customSwitch6"
                                                        :checked="row.view_in_sub_menu"
                                                        @click="onViewInSubMenu">
                                                    <label class="custom-control-label"
                                                        for="customSwitch6"
                                                        v-html="(row.view_in_sub_menu)
                                                            ? 'Show In Sub Menu'
                                                            : 'Hide In Sub Menu'">
                                                    </label>
                                                </div>
                                            </div>
                                            <!-- End View in sub menu -->
                                            <!--  Menu -->
                                            <div class="col-12 pt-3">
                                                <div class="form-group">
                                                    <div v-if="menuLoading" class="text-center">
                                                        <span class="spinner-grow spinner-grow-sm mr-1"
                                                            role="status"
                                                            aria-hidden="true">
                                                        </span>
                                                    </div>
                                                    <select v-bind:style="{display: inputDisplay}" class="form-control custom-select"
                                                        v-if="!menuLoading"
                                                        v-model="row.menu_id">
                                                        <option value="">Select Menu</option>
                                                        <option v-for="(menu, index) in menus"
                                                                :key="index"

                                                                :value="menu.id">
                                                                {{ menu.title }}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                            <!--  End Menu -->

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Nav Status -->

                </div>
                <!-- ******* End Navbar ******** -->


                    </div>
                </div>
                <!-- End Content -->


                    <!-- Button -->
                    <div class="col-md-12 row">
                        <div class="form-group mr-2">
                            <button class="btn btn-primary" :disabled="btnLoading">
                                <span v-if="btnLoading">
                                    <span class="spinner-grow spinner-grow-sm mr-1"
                                        role="status" aria-hidden="true">
                                    </span>Loading...
                                </span>
                                <span v-if="!btnLoading" class="ti-check-box"></span>
                                <span v-if="!btnLoading"> Update Restaurant</span>
                            </button>
                        </div>

                        <div class="form-group">
                            <button type="button" class="btn btn-danger"
                                :disabled="btnLoading"
                                @click="cancel">
                                <span class="ti-close"></span>
                                <span> Cancel </span>
                            </button>
                        </div>
                    </div>
                    <!-- End Button -->


                </form>
            </div>


                <Footer></Footer>
            </div>
        </main>
        <!-- End Main -->

    </div>
</template>

<script>
    import Header from '../layouts/Header.vue';
    import Navigation from '../layouts/Navigation';
    import Footer from '../layouts/Footer.vue';
    import Editor from '@tinymce/tinymce-vue';
    import Multiselect from 'vue-multiselect';
    import iziToast from 'izitoast';

    export default {
        name: 'Edit',
        components: {
            Header,
            Navigation,
            Editor,
            Footer,
            Multiselect
        },
        data(){
            return {
                //
                auth: {
                    role: '',
                    access_token: '',
                },
                row: {
                    // row
                    stars: '',
                    sort: 0,
                    title: '',
                    slug: '',
                    body: '',

                    // location & ratings
                    latitude: '',
                    longitude: '',
                    stars_no: '',
                    location: '',
                    phone_number: '',
                    services: '',
                    popular: '',

                    // relations
                    category_id: '',
                    tagsValues: [],
                    iconsValues: [],
                    faqsValues: [],

                    // meta
                    meta_title: '',
                    meta_keywords: '',
                    meta_description: '',

                    // opening hours (fixed 7 days, Sunday..Saturday)
                    openingHours: Array.from({ length: 7 }, (_, i) => ({
                        day_of_week: i, open_time: '', close_time: '', is_closed: false,
                    })),

                    // galleries
                    galleries: [],
                    gallery_key: 0,
                    gallery_image_preview: [],
                    gallery_image_base64: [],
                    gallery_image_alt: [],
                    gallery_image_title: [],

                    // featured menus (image-based)
                    menus: [],
                    menu_key: 0,
                    menu_image_preview: [],
                    menu_image_base64: [],
                    menu_image_alt: [],
                    menu_image_title: [],
                    menu_iframe: [],

                    // image
                    preview: '',
                    image_base64: '',
                    image_alt: '',
                    image_title: '',

                    // status & visibility
                    status: 1,
                    view_in_home: 0,
                    view_in_menu: 0,
                    view_in_sub_menu: 0,
                    menu_id: '',
                    menu_order: '',
                    //language
                    language_id: '',
                },
                editor: {
                    api_key: window.editor_apiKey,
                    menubar: window.editor_menubar,
                    plugins:[window.editor_plugins],
                    external_plugins: window.editor_external_plugins,
                    toolbar: window.editor_toolbar,
                },

                pgLoading: true,
                btnLoading: false,

                // Tenants
                tenant_id: 0,
                tenant_name: '',
                refs: 'restaurants',

                // menu
                menus: [],
                menuLoading: true,
                // input disabled
                inputDisplay: 'none',
                orderDisplay: 'none',

                // language
                languages: [],
                languageLoading: true,

                // category
                categories: [],
                categoryLoading: true,

                // tags & icons & faqs
                tagsOptions: [],
                tagsLoading: true,
                iconsOptions: [],
                iconsLoading: true,
                faqsOptions: [],
                faqsLoading: true,

                // opening hours day labels (index == day_of_week)
                dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
            }
        },
        mounted() {},
        computed: {},
        created() {
            // AccessToken & Role
            if(localStorage.getItem('role')) {
                this.auth.role = localStorage.getItem('role');
            }
            if(localStorage.getItem('access_token')) {
                this.auth.access_token = localStorage.getItem('access_token');
            }

            // Tenants
            if(localStorage.getItem('tenant_id')) {
                this.tenant_id = localStorage.getItem('tenant_id');
            }
            if(localStorage.getItem('tenant_name')) {
                this.tenant_name = localStorage.getItem('tenant_name');
            }

            this.fetchRow();
        },
        methods: {

            // fetchRow
            fetchRow() {
                this.pgLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/'+this.refs+'/'+this.$route.params.id,
                    method: 'GET',
                    data: {},
                    params: {},
                }
                this.axios(options)
                    .then(res => {
                    this.pgLoading = false;

                    // tenant
                    this.tenant_id = res.data.row.tenant_id;
                    this.tenant_name = res.data.row.tenant_name;

                    // row
                    this.row.stars = res.data.row.stars;
                    this.row.sort = res.data.row.sort;
                    this.row.title = res.data.row.title;
                    this.row.slug = res.data.row.slug;
                    this.row.body = res.data.row.body;

                    // location & ratings
                    this.row.latitude = res.data.row.latitude;
                    this.row.longitude = res.data.row.longitude;
                    this.row.stars_no = res.data.row.stars_no;
                    this.row.location = res.data.row.location;
                    this.row.phone_number = res.data.row.phone_number;
                    this.row.services = res.data.row.services;
                    this.row.popular = res.data.row.popular;

                    // relations
                    this.row.category_id = (res.data.row.category) ? res.data.row.category.id : null;
                    this.row.tagsValues = res.data.row.tags || [];
                    this.row.iconsValues = res.data.row.icons || [];
                    this.hydrateFaqsFromRow(res.data.row);

                    // meta
                    this.row.meta_title = (res.data.row.meta) ? res.data.row.meta.meta_title : null;
                    this.row.meta_keywords = (res.data.row.meta) ? res.data.row.meta.meta_keywords : null;
                    this.row.meta_description = (res.data.row.meta) ? res.data.row.meta.meta_description : null;

                    // opening hours - map API rows (by day_of_week) back into the fixed 7-slot array
                    const apiHours = res.data.row.opening_hours || [];
                    this.row.openingHours = Array.from({ length: 7 }, (_, i) => {
                        const found = apiHours.find(h => h.day_of_week === i);
                        return found
                            ? { day_of_week: i, open_time: found.open_time, close_time: found.close_time, is_closed: !!found.is_closed }
                            : { day_of_week: i, open_time: '', close_time: '', is_closed: true };
                    });

                    // galleries
                    const galleries = res.data.row.galleries || [];
                    galleries.forEach((gallery, idx) => {
                        const i = idx + 1;
                        this.row.gallery_image_preview[i] = gallery.image_url;
                        this.row.gallery_image_base64[i] = gallery.image_url;
                        this.row.gallery_image_alt[i] = gallery.image_alt;
                        this.row.gallery_image_title[i] = gallery.image_title;
                    });
                    this.row.gallery_key = galleries.length;

                    // featured menus
                    const menus = res.data.row.menus || [];
                    menus.forEach((menu, idx) => {
                        const i = idx + 1;
                        this.row.menu_image_preview[i] = menu.image_url;
                        this.row.menu_image_base64[i] = menu.image_url;
                        this.row.menu_image_alt[i] = menu.image_alt;
                        this.row.menu_image_title[i] = menu.image_title;
                        this.row.menu_iframe[i] = menu.iframe;
                    });
                    this.row.menu_key = menus.length;

                    // image
                    this.row.preview = (res.data.row.image) ? res.data.row.image.image_url : null;
                    this.row.image_base64 = (res.data.row.image ) ? res.data.row.image.image_url : null;
                    this.row.image_alt = (res.data.row.image ) ? res.data.row.image.image_alt : null;
                    this.row.image_title = (res.data.row.image ) ? res.data.row.image.image_title : null;

                    // status & visibility
                    this.row.status= res.data.row.status;

                    this.row.view_in_home = res.data.row.view_in_home;
                    this.row.view_in_menu = res.data.row.view_in_menu;
                    this.row.menu_order = res.data.row.menu_order;
                    this.row.view_in_sub_menu = res.data.row.view_in_sub_menu;
                    this.row.menu_id = res.data.row.menu_id;

                    //language
                    this.row.language_id = (res.data.row.language) ? res.data.row.language.id : null;

                    if (res.data.row.view_in_menu == 1) {
                        this.orderDisplay = 'block';
                    } else {
                        this.orderDisplay = 'none';
                    }

                    if (res.data.row.view_in_sub_menu == 1) {
                        this.inputDisplay = 'block';
                    } else {
                        this.inputDisplay = 'none';
                    }
                    // call fetchLanguages func
                    this.fetchLanguages();

                    })
                    .catch(() => {})
                    .finally(() => {});
            },

            // fetch Language
            fetchLanguages(){
                this.languageLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/languages',
                    method: 'GET',
                    data: {},
                    params: {
                        tenant_id: this.tenant_id,
                        status: 'active',
                        paginate: 100,
                    },
                }
                this.axios(options)
                    .then(res => {
                        this.languageLoading = false;
                        this.languages = res.data.rows;
                        this.fetchCategories(); // call next func
                    })
                    .catch(() => {})
                    .finally(() => {});
            },

            // fetchCategories
            fetchCategories() {
                this.categoryLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/categories',
                    method: 'GET',
                    data: {},
                    params: {
                        tenant_id: this.tenant_id,
                        status: 'active',
                        paginate: 100,
                    },
                }
                this.axios(options)
                .then(res => {
                    this.categoryLoading = false;
                    this.categories = res.data.rows;

                    this.fetchMultipleTags(); // call next function
                })
                .catch(() => {})
                .finally(() => {});
            },

            // fetchMultipleTags
            fetchMultipleTags(){
                this.tagsLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/tags',
                    method: 'GET',
                    data: {},
                    params: {
                        tenant_id: this.tenant_id,
                        status: 'active',
                        paginate: 100,
                    },
                }
                this.axios(options)
                .then(res => {
                    this.tagsLoading = false;
                    this.tagsOptions = res.data.tags;

                    this.fetchMultipleIcons(); // call next function
                })
                .catch(() => {})
                .finally(() => {});
            },

            // fetchMultipleIcons
            fetchMultipleIcons(){
                this.iconsLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/icons',
                    method: 'GET',
                    data: {},
                    params: {
                        tenant_id: this.tenant_id,
                        status: 'active',
                        paginate: 100,
                    },
                }
                this.axios(options)
                .then(res => {
                    this.iconsLoading = false;
                    this.iconsOptions = res.data.icons;

                    this.fetchFaqs(); // call next function
                })
                .catch(() => {})
                .finally(() => {});
            },

            // fetchFaqs
            fetchFaqs(){
                this.faqsLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/faqs',
                    method: 'GET',
                    data: {},
                    params: {
                        tenant_id: this.tenant_id,
                        status: 'active',
                        paginate: 1000,
                    },
                };
                this.axios(options)
                    .then(res => {
                        this.faqsOptions = res.data.rows || [];
                    })
                    .catch(() => { this.faqsOptions = []; })
                    .finally(() => { this.faqsLoading = false; });
            },

            // hydrateFaqsFromRow
            hydrateFaqsFromRow(row) {
                this.row.faqsValues = [];
                if (!row.faqs || !row.faqs.length) {
                    return;
                }
                const f = row.faqs;
                if (typeof f[0] === 'object' && f[0] !== null && f[0].id !== undefined) {
                    this.row.faqsValues = f.slice();
                } else {
                    this.row.faqsValues = f.map(id => this.faqsOptions.find(o => o.id === id)).filter(Boolean);
                }
            },

            // Galleries
            opnGalleryFrm() {
                this.row.gallery_key++;
            },
            removeGalleryOption(i) {
                document.querySelector('#galleryFrm_'+i).remove();
                this.row.gallery_image_preview[i] = '';
                this.row.gallery_image_base64[i] = '';
                this.row.gallery_image_alt[i] = '';
                this.row.gallery_image_title[i] = '';
            },
            onGalleryImageChange(e, i){
                const file = e.target.files[0];
                this.row.gallery_image_preview[i] = URL.createObjectURL(file);
                this.createBase64Gallery(file, i);
            },
            createBase64Gallery(fileObject, i){
                const reader = new FileReader();
                reader.readAsDataURL(fileObject);
                reader.onload = e =>{
                    this.row.gallery_image_base64[i] = e.target.result;
                };
            },

            // Featured Menus (image-based, mirrors Galleries)
            opnMenuFrm() {
                this.row.menu_key++;
            },
            removeMenuOption(i) {
                document.querySelector('#menuFrm_'+i).remove();
                this.row.menu_image_preview[i] = '';
                this.row.menu_image_base64[i] = '';
                this.row.menu_image_alt[i] = '';
                this.row.menu_image_title[i] = '';
                this.row.menu_iframe[i] = '';
            },
            onMenuImageChange(e, i){
                const file = e.target.files[0];
                this.row.menu_image_preview[i] = URL.createObjectURL(file);
                this.createBase64Menu(file, i);
            },
            createBase64Menu(fileObject, i){
                const reader = new FileReader();
                reader.readAsDataURL(fileObject);
                reader.onload = e =>{
                    this.row.menu_image_base64[i] = e.target.result;
                };
            },

            // editRow
            editRow(){
                if(this.tenant_id == 0) {

                    iziToast.warning({
                        icon: 'ti-alert',
                        title: 'Wow-man,',
                        message: 'No tenany selected.'
                    });

                } else {

                    if (this.row.status == false) {
                        this.row.status = 0;
                    } else {
                        this.row.status = 1;
                    }
                    if (this.row.view_in_home == false) {
                        this.row.view_in_home = 0;
                    } else {
                        this.row.view_in_home = 1;
                    }

                    if (this.row.view_in_menu == false) {
                        this.row.view_in_menu = 0;
                    } else {
                        this.row.view_in_menu = 1;
                    }

                    if (this.row.view_in_sub_menu == false) {
                        this.row.view_in_sub_menu = 0;
                    } else {
                        this.row.view_in_sub_menu = 1;
                    }

                    // galleries
                    for( let i = 1; i < this.row.gallery_image_base64.length; i++ ) {
                        if (this.row.gallery_image_base64[i]) {
                            this.row.galleries[i] = {
                                'gallery_image_base64' : this.row.gallery_image_base64[i],
                                'gallery_image_alt' : this.row.gallery_image_alt[i],
                                'gallery_image_title' : this.row.gallery_image_title[i]
                            }
                        }
                    }

                    // featured menus (image and/or iframe)
                    this.row.menus = [];
                    for( let i = 1; i <= this.row.menu_key; i++ ) {
                        if (this.row.menu_image_base64[i] || this.row.menu_iframe[i]) {
                            this.row.menus[i] = {
                                'menu_image_base64' : this.row.menu_image_base64[i] || '',
                                'menu_image_alt' : this.row.menu_image_alt[i] || '',
                                'menu_image_title' : this.row.menu_image_title[i] || '',
                                'menu_iframe' : this.row.menu_iframe[i] || ''
                            }
                        }
                    }

                    this.btnLoading = true;
                    this.axios.defaults.headers.common = {
                        'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                        'Authorization': `Bearer ` + this.auth.access_token,
                    };
                    const config = { headers: { 'Content-Type': 'multipart/form-data' }};
                    const options = {
                        url: window.baseURL+'/'+this.refs+'/'+this.$route.params.id,
                        method: 'PUT',
                        data: {
                            tenant_id: this.tenant_id,
                            // row
                            stars: this.row.stars,
                            sort: this.row.sort,
                            title: this.row.title,
                            slug: this.row.slug,
                            body: this.row.body,

                            // location & ratings
                            latitude: this.row.latitude,
                            longitude: this.row.longitude,
                            stars_no: this.row.stars_no,
                            location: this.row.location,
                            phone_number: this.row.phone_number,
                            popular: this.row.popular,

                            // relations
                            category_id: this.row.category_id,
                            tags: this.row.tagsValues,
                            services: this.row.services,
                            icons: this.row.iconsValues,
                            faqs: (this.row.faqsValues || []).map(f => f.id),

                            // meta
                            meta_title: this.row.meta_title,
                            meta_keywords: this.row.meta_keywords,
                            meta_description: this.row.meta_description,

                            // opening hours
                            opening_hours: this.row.openingHours,

                            // galleries
                            galleries: this.row.galleries,

                            // featured menus
                            menus: this.row.menus,

                            // image
                            image_base64: this.row.image_base64,
                            image_alt: this.row.image_alt,
                            image_title: this.row.image_title,

                            // status & visiblity
                            status: this.row.status,
                            view_in_home: this.row.view_in_home,
                            view_in_menu: this.row.view_in_menu,
                            menu_order: this.row.menu_order,
                            view_in_sub_menu: this.row.view_in_sub_menu,
                            menu_id: this.row.menu_id,

                             //language
                            language_id: this.row.language_id,
                        }
                    }
                    this.axios(options, config)
                        .then(() => {
                            this.btnLoading = false;
                            iziToast.success({
                                icon: 'ti-check',
                                title: 'Great job,',
                                message: 'Item Updated Successfully.',
                            });
                            this.$router.push({ name: this.refs });
                        })
                        .catch(err => {
                            // 403 Forbidden
                            if(err.response && err.response.status == 401) {
                                this.removeLocalStorage();
                                this.$router.push({ name: 'login' });
                            } else if(err.response && err.response.status == 403) {
                                this.$router.push({ name: 'forbidden' });
                            } else {
                                this.btnLoading = false;
                                iziToast.warning({
                                    icon: 'ti-alert',
                                    title: 'Wow-man,',
                                    message: (err.response) ? err.response.data.message : ''+err
                                });
                            }
                        })
                        .finally(() => {})
                }
            },


            // Title
            onTitleChange() {
                // this.onSlugChange(this.row.title);
            },

            // on Paste
            onSlugPaste(){
                let str = this.row.slug;
                this.onSlugChange(str);
            },
            onSlugChange(str){
                if(!str) {
                   let str = this.row.slug;
                   this.row.slug = str.replace(/\s+/g, '-');
                } else {
                    this.row.slug = str.replace(/\s+/g, '-');
                }
            },

            // Upload Featured image
            onImageChange(e){
                const file = e.target.files[0];
                this.row.preview = URL.createObjectURL(file);
                this.createBase64Image(file);
            },
            createBase64Image(fileObject){
                const reader = new FileReader();
                reader.readAsDataURL(fileObject);
                reader.onload = e =>{
                    this.row.image_base64 = e.target.result;
                };
            },

            // active status
            onStatus(){
                if(this.row.status)
                    this.row.status = 0;
                else
                    this.row.status = 1;
            },

            // view in home
            onViewInHome(){
                if(this.row.view_in_home)
                    this.row.view_in_home = 0;
                else
                    this.row.view_in_home = 1;
            },
            // view in menu
            onViewInMenu(){
                if(this.row.view_in_menu) {
                    this.row.view_in_menu = 0;
                    this.orderDisplay = 'none';
                }
                else {
                    this.row.view_in_menu = 1;
                    this.orderDisplay = 'block';
                }
            },
            // view in sub menu
            onViewInSubMenu(){
                if(this.row.view_in_sub_menu) {
                    this.row.view_in_sub_menu = 0;
                    this.inputDisplay = 'none';
                }
                else {
                    this.row.view_in_sub_menu = 1;
                    this.inputDisplay = 'block';
                }
            },

            // fetchMenus
            fetchMenus() {
                this.menuLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/menus',
                    method: 'GET',
                    data: {},
                    params: {
                        tenant_id: this.tenant_id,
                        paginate: 100,
                    },
                }
                this.axios(options)
                .then(res => {
                    this.menuLoading = false;
                    this.menus = res.data.rows;
                })
                .catch(() => {})
                .finally(() => {});
            },

            // remove sessions
            removeLocalStorage() {
                localStorage.removeItem('access_token');
                localStorage.removeItem('user_image');
                localStorage.removeItem('user_name');
                localStorage.removeItem('user_id');
                localStorage.removeItem('role');
                localStorage.removeItem('tenant_id');
            },


            // toggleCollapse
            collapseToggle(div) {
                if (div == 'Status') {
                    this.fetchMenus();
                }
                let el = document.querySelector("span#iconToggle"+div);
                if(el.classList.contains('ti-angle-down')) {
                    el.classList.remove('ti-angle-down');
                    el.classList.add('ti-angle-up');
                } else {
                    el.classList.remove('ti-angle-up');
                    el.classList.add('ti-angle-down');
                }
            },

            // Cancel
            cancel(){
                if(confirm('Are You Sure?')) {
                    this.$router.push({ name: this.refs });
                }
            },

        },
    }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
